module.exports = __webpack_public_path__ + "media/group@2x.5d2b46a5.jpg";